export const ADD_CREDIT_CARD_MODAL_NAME = 'ADD_CREDIT_CARD_MODAL_NAME';
